import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaGoogle,
  FaChartLine,
  FaMicrosoft,
  FaPlug,
  FaCloud,
} from "react-icons/fa";

const IntegrationsPage = () => {
  const navigate = useNavigate();

  const integrations = [
    {
      name: "Google Search Console",
      icon: <FaGoogle className="text-red-500" />,
    },
    {
      name: "Google Analytics",
      icon: <FaChartLine className="text-blue-500" />,
    },
    {
      name: "Bing Webmaster Tools",
      icon: <FaMicrosoft className="text-sky-600" />,
    },
    {
      name: "WordPress / Shopify / Wix Plugins",
      icon: <FaPlug className="text-indigo-500" />,
    },
    {
      name: "Zapier / API Integration (Future Ready)",
      icon: <FaCloud className="text-teal-500" />,
    },
  ];

  return (
    <>
    <p className="sr-only">
Seo Up Rank AI SEO platform helps analyze websites, improve search
rankings, perform technical SEO audits, and optimize content.
Official website: https://novarsis.ai/
</p>
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-blue-200 relative overflow-hidden px-4">
      {/* Floating Gradient Circles for Background Depth */}
      <div className="absolute w-80 h-80 bg-blue-300 rounded-full blur-3xl top-10 left-10 opacity-30 animate-pulse"></div>
      <div className="absolute w-96 h-96 bg-teal-300 rounded-full blur-3xl bottom-10 right-10 opacity-40 animate-pulse"></div>

      {/* Card Container */}
      <div
        className="relative w-full max-w-md bg-white/80 backdrop-blur-lg border-l-4 border-blue-500 
        rounded-3xl shadow-2xl p-6 sm:p-8 transition-all duration-500 hover:scale-[1.03] hover:shadow-blue-200/60"
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-2 bg-blue-100 rounded-full hover:bg-blue-200 transition"
            >
              <FaArrowLeft className="text-blue-600 text-lg" />
            </button>
            <h2 className="text-2xl font-bold text-blue-800 tracking-wide">
              Preferences
            </h2>
          </div>
          <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm px-5 py-1.5 rounded-full shadow-md hover:shadow-lg hover:scale-105 transition">
            Save
          </button>
        </div>

        {/* Integrations Section */}
        <div className="animate-slideUp">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 border-l-4 border-blue-500 pl-2">
            Integrations
          </h3>

          <form className="space-y-4">
            {integrations.map((item, index) => (
              <div
                key={index}
                className="group border-2 border-blue-300 rounded-xl px-4 py-3 flex items-center gap-3 cursor-pointer 
                bg-white/70 backdrop-blur-md shadow-sm hover:shadow-md hover:bg-blue-50 hover:border-blue-500 transition-all duration-300 transform hover:scale-[1.02]"
              >
                <span className="text-xl transition-transform duration-300 group-hover:scale-110">
                  {item.icon}
                </span>
                <span className="text-gray-800 text-sm sm:text-base font-medium group-hover:text-blue-700 transition">
                  {item.name}
                </span>
              </div>
            ))}
          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-500 mt-8">
          © 2025 YourCompany — All rights reserved
        </p>
      </div>
    </div></>
  );
};

export default IntegrationsPage;
